import React from "react";
import { Grid } from "semantic-ui-react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import LOKanbanCard from "./LOKanbanCard";
import BCKanbanLane from "./BCKanbanLane";
import "../../styles/kanban.scss";
import BCCards from "./BCCards";

interface BPProps {
  kanbanClass?;
  data; 
  setData; 
  handleCard?; 
  freezeLanes?;
  isGreaterThanMobile?;
  infoData?;
  handleInfo?;
  displayList?;
  handleGMR?;
  handleCopyGMR?;
  handleSummary?;
  handleApplication?;
  handleCopyApplication?;
  labels?;
  ellipsis?;
  brokerColor?;
}

const BCKanban = ({ ...props }: BPProps) => {
  const fittedViewMax = 3;
  const moveCard = (card: any, draggedIndex: number, atIndex: number, draggedCategory: number, category: number) => {
    if (draggedCategory !== category) {
      props.setData(
        update(props.data, {
          [draggedCategory]: {
            cards: {
              $splice: [
                [draggedIndex, 1]
              ],
            }
          },
          [category]: {
            cards: {
              $splice: [
                [atIndex, 0, card]
              ],
            }
          }
        }),
      );
    }
    else {
      props.setData(
        update(props.data, {
          [category]: {
            cards: {
              $splice: [
                [draggedIndex, 1],
                [atIndex, 0, card],
              ],
            }
          }
        }),
      );
    }
   
  };

  const findCard = (id: string, category: number) => {
    const item = props.data.find(x => x.index === category);
    const card = item.cards.find(x => x.id === id);
    return {
      card,
      index: item.cards.indexOf(card)
    };
  };

  const handleDrop = React.useCallback(
    (targetCategoryIndex: number, item: any, cards: any) => {
      const originCategory = cards.find(x => {
        return x.cards.find(y => y.id === item.id);
      });
      const draggedCard = originCategory.cards.find(x => x.id === item.id);
      if (originCategory.index !== targetCategoryIndex) {
        props.setData(
          update(cards, {
            [originCategory.index]: {
              cards: {
                $splice: [
                  [item.originalIndex, 1]
                ],
              }
            },
            [targetCategoryIndex]: {
              cards: {
                $splice: [
                  [0, 0, draggedCard]
                ],
              }
            }
          }),
        );
      }
    },
    [props],
  );

  const NewlineText = (props) => {
    const text = props.text;
    const newText = text.split("\n").map((str, i) => <p  key={"kanban_newline_text" + i}>{str}</p>);
    return newText;
  };

  return (
    <div className={props.kanbanClass ? props.kanbanClass : "kanban-container"}>
      <DndProvider backend={HTML5Backend}>
      <Grid className={props.data && props.data.length > fittedViewMax ? "kanban-grid-overflow" : ""} columns={props.data && props.data.length}>
        <Grid.Row className={props.data && props.data.length > fittedViewMax ?"kanban-row-overflow kanban-row" : "kanban-row"}>
          {props.data && props.data.map((item, i) => {
            return (
              <Grid.Column key={"kanban_header_" + i} className={props.data && props.data.length > fittedViewMax ? "kanban-column-fixed kanban-column" : "kanban-column"}>
                <NewlineText text={item.name.toUpperCase()} />
              </Grid.Column>
            );
          })}
        </Grid.Row>
        <Grid.Row className={props.data && props.data.length > fittedViewMax ?"kanban-row-overflow kanban-row" : "kanban-row"}>
          {props.data && props.data.map((item, i) => {
            return (
              <Grid.Column key={"kanban_lane_" + i} className={props.data && props.data.length > fittedViewMax ?"kanban-column-fixed kanban-column" : "kanban-column"}>
                <BCKanbanLane
                  accept={["card"]}
                  onDrop={(item) => handleDrop(i, item, props.data)}
                  key={i}
                >
                  {(item && item.cards.length !== 0) && props.freezeLanes === true ? <BCCards
                    isGreaterThanMobile={props.isGreaterThanMobile && props.isGreaterThanMobile} 
                    infoData={item.cards && item.cards} 
                    handleInfo={props.handleInfo && props.handleInfo} 
                    displayList={item.cards}
                    handleSummary={props.handleSummary}
                    handleGMR={props.handleGMR && props.handleGMR}
                    handleCopyGMR={props.handleCopyGMR && props.handleCopyGMR}
                    handleApplication={props.handleApplication && props.handleApplication}
                    handleCopyApplication={props.handleCopyApplication && props.handleCopyApplication}
                    ellipsis={props.ellipsis && props.ellipsis}
                    labels={props.labels && props.labels}
                    isKanban
                    brokerColor={props.brokerColor}
                  /> : (item && item.cards.length !== 0) && item.cards.map((card, j) => {
                    return (
                        <LOKanbanCard
                        key={card.id}
                        id={card.id}
                        index={j}
                        card={card}
                        category={item.index}
                        cards={props.data}
                        moveCard={moveCard}
                        findCard={findCard}
                        handleCard={props.handleCard}
                      />
                    );
                  })}
                </BCKanbanLane>
              </Grid.Column>
            );
          })}
        </Grid.Row>
      </Grid>
      </DndProvider>
    </div>
  );
};

export default BCKanban;